import { cx } from '@emotion/css';
import { Icon } from '@snapchat/snap-design-system-marketing';
import type { FC } from 'react';
import { useContext } from 'react';

import { ShopifyContext } from '../ShopifyProvider';
import { Price } from './Price';
import {
  atpCss,
  cartItemImg,
  cartItemWrapperCss,
  priceCss,
  quantityCss,
  quantityModificationCss,
  quantityModificationDisabledCss,
  quantityWrapperCss,
  titleCss,
} from './styles';
import type { ShopifyProduct } from './types';

export const CartItem: FC<ShopifyProduct> = ({
  image,
  atpMessage,
  price,
  handle,
  id,
  maxQuantity,
  variantTitle,
}) => {
  const { cart, products, currencyCode = '' } = useContext(ShopifyContext);

  const contentfulProduct = products?.contentful[handle] ?? {};

  // Cart is keyed by variant ID
  const cartKey = id;
  const quantity = cart.lineItems[cartKey] ?? 0;
  const buttonDisabled = maxQuantity === quantity;

  return (
    <div className={cartItemWrapperCss}>
      <div className={cartItemImg(image)} />
      <div className={titleCss}>
        {contentfulProduct.title}
        {variantTitle && variantTitle !== 'Default Title' ? ` - ${variantTitle}` : ''}
      </div>
      <Price className={priceCss} productPrice={price} />
      <div className={quantityWrapperCss}>
        <button
          onClick={() =>
            cart.removeOne({
              handle,
              variantId: cartKey,
              contentfulProduct,
              shopifyProducts: products.shopify,
              currencyCode,
            })
          }
          className={quantityModificationCss}
        >
          <Icon name="remove" />
        </button>
        <span className={quantityCss}>{quantity}</span>
        <button
          disabled={buttonDisabled}
          onClick={() =>
            cart.addOne({
              handle,
              variantId: cartKey,
              contentfulProduct,
              shopifyProducts: products.shopify,
              currencyCode,
            })
          }
          className={cx(quantityModificationCss, {
            [quantityModificationDisabledCss]: buttonDisabled,
          })}
        >
          <Icon name="add" />
        </button>
      </div>
      {atpMessage && <div className={atpCss}>{atpMessage}</div>}
    </div>
  );
};
